export default __webpack_public_path__ + "static/media/a017-6.c22d6adb.svg";